import tree from "../../../../components/tree.vue";
import DataPage from "./DataPage/DataPage.vue";
import DayTime from "./DayTime/DayTime.vue";
import MonthTime from "./MonthTime/MonthTime.vue";
import ChangeTime from "./ChangeTime/ChangeTime.vue";

export default {
  name: "Comprehensive",
  components: {
    tree,
    DataPage,
    DayTime,
    MonthTime,
    ChangeTime
  },
  data() {
    return {
      isCollapse: false,
      stateArrow: true,
      isSearch: true,
      activeName: 'first',
      orgId: '',
    };
  },
  mounted() {

  },
  methods: {
    toggleSideBar() {
      this.isCollapse = !this.isCollapse
      this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
    },
    changeArrow() {
      this.stateArrow = !this.stateArrow
    },
    handleClick(event) {
      this.activeName = event.name
      if (this.activeName == 'first') {
        this.$nextTick(() => {
          this.$refs.dayTime.orgId = this.orgId
          this.$refs.dayTime.getRankStopCount()
          this.$refs.dayTime.getWorkBarGraph()
          this.$refs.dayTime.getFaultBarGraph()
          this.$refs.dayTime.getCarOrderList()
        })
      } else if (this.activeName == 'second') {
        this.$nextTick(() => {
          this.$refs.monthTime.orgId = this.orgId
          this.$refs.monthTime.getMonthRankStop()
          this.$refs.monthTime.getMonthWork()
          this.$refs.monthTime.getMonthFault()
          this.$refs.monthTime.getMonthOrderList()
        })
      } else if (this.activeName == 'third') {
        this.$nextTick(() => {
          this.$refs.dataRef.orgId = this.orgId
          this.$refs.dataRef.getRankStopTotal()
          this.$refs.dataRef.getWorkTotal()
          this.$refs.dataRef.getFaultTotal()
          this.$refs.dataRef.getTotalOrderList()
        })

      } else {
        this.$nextTick(() => {
          this.$refs.changeTime.orgId = this.orgId
          this.$refs.changeTime.getChangeRankStop()
          this.$refs.changeTime.getChangeWork()
          this.$refs.changeTime.getChangeFault()
          this.$refs.changeTime.getChangeOrderList()
        })

      }
    },
    initQuery(item) {
      this.orgId = item.id
      if (this.activeName == 'first') {
        this.$refs.dayTime.orgId = item.id
        this.$refs.dayTime.getRankStopCount()
        this.$refs.dayTime.getWorkBarGraph()
        this.$refs.dayTime.getFaultBarGraph()
        this.$refs.dayTime.getCarOrderList()
      }
    },
    nodeClick(val) {
      this.orgId = val.label
      if (this.activeName == 'first') {
        this.$refs.dayTime.orgId = val.label
        this.$refs.dayTime.getRankStopCount()
        this.$refs.dayTime.getWorkBarGraph()
        this.$refs.dayTime.getFaultBarGraph()
        this.$refs.dayTime.getCarOrderList()
      } else if (this.activeName == 'second') {
        this.$refs.monthTime.orgId = val.label
        this.$refs.monthTime.getMonthRankStop()
        this.$refs.monthTime.getMonthWork()
        this.$refs.monthTime.getMonthFault()
        this.$refs.monthTime.getMonthOrderList()
      } else if (this.activeName == 'third') {
        this.$refs.dataRef.orgId = val.label
        this.$refs.dataRef.getRankStopTotal()
        this.$refs.dataRef.getWorkTotal()
        this.$refs.dataRef.getFaultTotal()
        this.$refs.dataRef.getTotalOrderList()
      } else {
        this.$refs.changeTime.orgId = val.label
        this.$refs.changeTime.getChangeRankStop()
        this.$refs.changeTime.getChangeWork()
        this.$refs.changeTime.getChangeFault()
        this.$refs.changeTime.getChangeOrderList()
      }
    },
    onResize: function (x, y, width, height) {
      let box = document.getElementById("leftBox");
      box.style.width = width + "px";
    },
  },
};
